import { FormGroup } from '@angular/forms';
import { UserRoles } from 'src/app/core/components/user-admin-page/user-model';
import { CatalogScope } from '../models/catalog-scope.enum';

/**
 * Determines if a catalog item can be deleted based on user permissions and item properties
 * @param itemFg The form group representing the catalog item
 * @param userRoles The current user's roles
 * @returns true if the item should NOT be deleted (locked or insufficient permissions), false if it can be deleted
 */
export function cannotDeleteCatalogItem(itemFg: FormGroup, userRoles: UserRoles): boolean {
  const isAdmin = userRoles?.catalogAdmin;
  const scope = itemFg.get('scope')?.value;
  const isLocked = itemFg.get('isLocked')?.value;

  return isLocked || (!isAdmin && scope !== CatalogScope.User);
}
